var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xrTagAdd"},[_vm._l((_vm.list),function(tag,index){return _c('el-tag',{key:index,attrs:{"closable":"","type":"info"},on:{"close":function($event){return _vm.handleClose(index, tag)}}},[_vm._v(_vm._s(tag))])}),_vm._v(" "),_c('i',{staticClass:"el-icon-circle-plus-outline xrTagAdd-icon",on:{"click":_vm.addTag}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2113a96b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/XrTagAdd/index.vue
// module id = null
// module chunks = 